const EditSiloGroupChannelMapping = ({
    device,
    POSITIONS_OPTIONS,
    getOccupiedPositions,
    onChannelEnableToggle,
    onPositionChange,
    onPositionFocus
}) => {

    const renderDropdown = (channel, options, isDisabled = false) => (
        <select
            value={channel.mappedPosition || ''}
            onChange={(e) => onPositionChange(device.deviceId, channel.channelId, e.target.value ? (e.target.value) : null,e.target.options[e.target.selectedIndex].text)}
            onFocus={() => onPositionFocus(channel.mappedPosition)}
            onBlur={() => onPositionFocus(null)} //
            style={{
                width: '100%',
                padding: '8px',
                border: '1px solid #ccc',
                borderRadius: '4px',
                backgroundColor: '#fff',
                fontSize: '14px',
                boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
            }}
            disabled={isDisabled}
        >
            <option value="">--</option>
            {options.map(option => (
                <option
                    key={option.value}
                    value={option.value}
                    disabled={
                        getOccupiedPositions.has(option.value) && option.value !== channel.mappedPosition
                    }
                >
                    {option.label}
                </option>
            ))}
        </select>
    );

    return (
        <div
            style={{
                backgroundColor: '#fff',
                border: '1px solid #e0e0e0',
                borderRadius: '8px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                marginBottom: '24px',
                overflow: 'hidden'
            }}
        >
            {/* Header */}
            <div style={{
                padding: '16px',
                fontWeight: '600',
                fontSize: '18px',
                color: '#fff',
                backgroundColor: device.deviceAlias === 'Inner Layer' ? '#38761d' : '#4a4a4a',
                borderRadius: '8px 8px 0 0',
            }}>
                {device.deviceId} — Alias: {device.deviceAlias}
            </div>

            {/* Table Header (Grid definition structure) */}
            <div className="grid-channel-header" style={{
                padding: '12px',
                fontSize: '12px',
                fontWeight: '500',
                color: '#666',
                backgroundColor: '#f8f8f8',
                textTransform: 'uppercase',
                borderBottom: '1px solid #e0e0e0',
                display: 'grid', /* Re-defining grid structure here for safety */
                gridTemplateColumns: '1.5fr 1fr 1.5fr',
                gap: '10px'
            }}>
                <div>Channel</div>
                <div>Status</div>
                <div>Map to Position</div>
            </div>

            {/* Channels */}
            {device.channels.map(channel => {
                const isPositionDisabled = !channel.isEnabled;
                const isMapped = !!channel.mappedPosition;

                return (
                    <div
                        key={channel.channelId}
                        className="grid-channel-row"
                        onMouseEnter={() => onPositionFocus(channel.mappedPosition)}
                        onMouseLeave={() => onPositionFocus(null)}
                        style={{
                            padding: '12px',
                            fontSize: '14px',
                            alignItems: 'center',
                            borderBottom: '1px solid #eee',
                            backgroundColor: isMapped ? '#f0f4ff' : '#fff',
                            display: 'grid', /* Re-defining grid structure here for safety */
                            gridTemplateColumns: '1.5fr 1fr 1.5fr',
                            gap: '10px'
                        }}
                    >
                        {/* Channel Name */}
                        <div style={{ fontWeight: '500', color: '#333' }}>{channel.channelName}</div>

                        {/* Status Toggle */}
                        <div>
                            <button
                                onClick={() => onChannelEnableToggle(device.deviceId, channel.channelId)}
                                style={{
                                    padding: '4px 8px',
                                    borderRadius: '16px',
                                    border: 'none',
                                    fontSize: '12px',
                                    fontWeight: '500',
                                    backgroundColor: channel.isEnabled ? '#d4edda' : '#f8d7da',
                                    color: channel.isEnabled ? '#155724' : '#721c24',
                                    cursor: 'pointer',
                                }}
                            >
                                {channel.isEnabled ? 'Enabled' : 'Disabled'}
                            </button>
                        </div>

                        {/* Position Dropdown */}
                        <div>
                            {renderDropdown(channel, POSITIONS_OPTIONS, isPositionDisabled)}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};
export default EditSiloGroupChannelMapping